import { Text, type TextStyleOptions } from "pixi.js";
import { LocalizedText } from "../../localization/LocalizedText";
import type { LocalizationService } from "../../localization/LocalizationService";

/** Roboto Medium, centred — the `cc.Label` + `LocalizedLabel` pair every modal panel's text block uses (the shell's since decision 46). */
const MODAL_LABEL_FONT = "Roboto, system-ui, sans-serif";

export interface ModalLabelSpec {
  fontSize: number;
  color: number;
  /** Pixi y (the y-up value negated). */
  y: number;
  weight?: "300" | "500" | "700";
  /** `enableOutline` width (black), 0/absent = none. */
  outline?: number;
  label?: string;
}

function modalLabelStyle(spec: ModalLabelSpec): TextStyleOptions {
  return {
    fill: spec.color,
    fontSize: spec.fontSize,
    fontFamily: MODAL_LABEL_FONT,
    fontWeight: spec.weight ?? "500",
    align: "center",
    ...(spec.outline ? { stroke: { color: 0x000000, width: spec.outline } } : {}),
  };
}

/** A localized modal label (`LocalizedLabel`). */
export function createLocalizedModalLabel(input: { localization: LocalizationService; key: string; fallback: string } & ModalLabelSpec): LocalizedText {
  const text = new LocalizedText({ localization: input.localization, key: input.key, fallback: input.fallback, style: modalLabelStyle(input), label: input.label });
  text.position.set(0, input.y);
  return text;
}

/** A plain modal label whose string the panel sets (amounts, counts). */
export function createModalLabel(spec: ModalLabelSpec): Text {
  const text = new Text({ text: "", style: modalLabelStyle(spec), label: spec.label ?? "Label" });
  text.anchor.set(0.5);
  text.position.set(0, spec.y);
  return text;
}
